
import React, { useState, useEffect } from "react";

import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "@material-ui/core/Card";
import Avatar from "@material-ui/core/Avatar";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import Badge from "@material-ui/core/Badge";
import Fab from "@material-ui/core/Fab";
import Hidden from "@material-ui/core/Hidden";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import Paper from "@material-ui/core/Paper";


import { withStyles } from "@material-ui/core/styles";
import TimerIcon from "@material-ui/icons/Timer";
import GroupIcon from "@material-ui/icons/Group";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import StarIcon from "@material-ui/icons/Star";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
	// some basic styles to make the items look a bit nicer
	userSelect: "none",
	//padding: grid * 2,
	margin: `0 0 8px 0`,

	// change background colour if dragging
	//background: isDragging ? "lightgreen" : "grey",

	// styles we need to apply on draggables
	...draggableStyle
});

const getListStyle = isDraggingOver => ({
	// background: isDraggingOver ? "lightblue" : "lightgrey",
	padding: 0
});

const styles = theme => ({
	companyCard: {
		marginBottom: 10
	},
	companyName: {
		lineHeight: "1.2em"
	},
	selectedPositionChip: {
		marginRight: 5,
		marginBottom: 5,
		height: 25
	},
	orderButton: {
		"@media (max-width: 500px)": {
			padding: 0
		}
	},
	dragIndicator: {
		marginTop: 15,
		marginBottom: 15
	},
	subgroup: {
		padding: 30,
	},
	excludeCompany: {
		maxWidth: "100%",
		overflow: "hidden",
		"& > span:last-child": {
			maxWidth: "calc(100% - 48px)",
			flexGrow: 1
		}
	},
	excludeCompanyName: {
		lineHeight: "1.2em",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	// mobileBottomBar: {
	// 	position: "fixed",
	// 	bottom: 0,
	// 	left: 0,
	// 	width: "100%",
	// 	backgroundColor: "#fff",
	// 	padding: 10
	// }
});

const CompanyPriorities = ({ companies, participant, handleFieldChange, setActiveStep, language, classes, favorites, setFavorites }) => {
	const [jobpositions, setJobPositions] = useState({});
	const [companyOpenInDialog, setCompanyOpenInDialog] = useState(null);

	const setFilterDefaults = (cp) => {
		const newJobPositions = {};
		cp.forEach(company => {
			company.jobpositions.forEach(pos => {
				if (!newJobPositions.hasOwnProperty(pos.ID))
					newJobPositions[pos.ID] = { ...pos, selected: false };
			})
		})
		setJobPositions(newJobPositions);
	}

	useEffect(() => {
		if (companies) {
			setFilterDefaults(companies);
		}

	}, [companies]);

	const onDragEnd = result => {
		// dropped outside the list
		if (!result.destination) {
			return;
		}

		const newFavorites = reorder(
			favorites,
			result.source.index,
			result.destination.index
		);

		setFavorites(newFavorites);
	};

	if (!companies || companies.length === 0) return <div />;

	const favoriteCompanyIds = favorites.map(favorite => favorite.id);
	return (
		<div>
			<Grid
				container
				direction="row"
				justify="space-between"
				alignItems="flex-start"
				spacing={16}
			>
				<Grid item xs={12}>
					<Typography variant="h3">
						{language === "en" ? "Sort your favorites according to your priorities" : "Sortiere deine Favoriten nach deinen Prioritäten"}
					</Typography>
					<Typography variant="body1" gutterBottom>
						{language === "en" ? "We try to take your priorities into account as best as possible, but we cannot guarantee anything. If you get an acceptation, you will receive a minimum of 1 and a maximum of 4 interview appointments." : "Wir versuchen deine Prioritäten so gut als möglich zu berücksichtigen, können aber nichts garantieren. Bei einer Zusage bekommst du min. 1 und max. 4 Gesprächstermine."}
					</Typography>
					<div className={classes.favorites}>
						<DragDropContext onDragEnd={onDragEnd}>
							<Droppable droppableId="droppable">
								{(provided, snapshot) => (
									<div
										ref={provided.innerRef}
										style={getListStyle(snapshot.isDraggingOver)}
									>
										{favorites.map((favorite, favoriteIndex) => {
											const company = companies.find(cp => cp.id === favorite.id);
											if (!company) return null;
											const selectedPositions = favorite.positions
												.filter(pos_id => jobpositions[pos_id] && jobpositions[pos_id].name)
												.map(pos_id => jobpositions[pos_id].name);
											return (
												<Draggable
													key={company.id}
													draggableId={company.id}
													index={favoriteIndex}
													isDragDisabled={false}
												>
													{(provided, snapshot) => (
														<div
															ref={provided.innerRef}
															{...provided.draggableProps}
															{...provided.dragHandleProps}
															style={getItemStyle(
																snapshot.isDragging,
																provided.draggableProps.style
															)}
														>
															<Card
																key={company.id}
																className={classes.companyCard}
															>
																<CardContent>
																	<Grid container spacing={8}>
																		<Grid item xs={1} align="center">
																			<IconButton
																				className={classes.orderButton}
																				disabled={favoriteIndex === 0}
																				onClick={() => {
																					// sort one up
																					const newFavorites = [...favorites];
																					const temp = newFavorites[favoriteIndex - 1];
																					newFavorites[favoriteIndex - 1] = favorite;
																					newFavorites[favoriteIndex] = temp;
																					setFavorites(newFavorites);
																				}}
																			>
																				<ExpandLessIcon />
																			</IconButton>
																			<DragIndicatorIcon className={classes.dragIndicator} />
																			<IconButton
																				className={classes.orderButton}
																				disabled={favoriteIndex === favorites.length - 1}
																				onClick={() => {
																					// sort one up
																					const newFavorites = [...favorites];
																					const temp = newFavorites[favoriteIndex + 1];
																					newFavorites[favoriteIndex + 1] = favorite;
																					newFavorites[favoriteIndex] = temp;
																					setFavorites(newFavorites);
																				}}
																			>
																				<ExpandMoreIcon />
																			</IconButton>
																		</Grid>
																		<Grid item xs={11}>
																			<Grid container spacing={8}>
																				<Grid item xs={9}>
																					<Typography
																						variant="h3"
																						gutterBottom
																						className={classes.companyName}
																					>
																						{company.name}
																					</Typography>
																				</Grid>
																				{company.logo_url &&
																					<Grid item xs={3} align="right">
																						<img src={company.logo_url} alt={company.name} style={{ width: 60 }} />
																					</Grid>
																				}
																				<Grid item xs={12}>
																					{selectedPositions.map(selectedPosition =>
																						<Chip
																							key={selectedPosition}
																							variant="outlined"
																							label={selectedPosition}
																							className={classes.selectedPositionChip}
																						/>
																					)}
																				</Grid>
																				{/* <Grid item xs={12} align="right">
														<br />
														<Button
															size="small"
															color="default"
															variant="contained"
															onClick={() => {
																setCompanyOpenInDialog(company);
															}}
														>
															{language === "en" ? "change" : "ändern"}
														</Button>
													</Grid> */}
																				<Grid item xs={12}>
																					<TextField
																						label={language === "en" ? "Why do you want to work here?" : "Warum möchtest du hier arbeiten?"}
																						multiline
																						rows="3"
																						value={favorite.why ? favorite.why : ""}
																						onChange={e => {
																							const newFavorites = [...favorites];
																							newFavorites[favoriteIndex].why = e.target.value;
																							setFavorites(newFavorites);
																						}}
																						fullWidth
																						variant="outlined"
																					/>
																				</Grid>
																			</Grid>
																		</Grid>
																	</Grid>
																</CardContent>
															</Card>
														</div>
													)}
												</Draggable>
											);
										})}
										{provided.placeholder}
									</div>
								)}
							</Droppable>
						</DragDropContext>
					</div>
					<br />
					<br />

				</Grid>

				<Grid item xs={12}>
					<br />
					<Typography variant="h3">
						{language === "en" ? "Mark companies you are NOT considering" : "Markiere Unternehmen, die du NICHT in Betracht ziehst"}
					</Typography>
					<Typography variant="body1" gutterBottom>
						{language === "en" ? "We may also book you with other companies. If there are companies that you absolutely do not want to have a conversation with, please indicate them here." : "Es kann sein, dass wir dich auch bei anderen Unternehmen einbuchen. Wenn es Unternehmen gibt, mit denen du auf gar keinen Fall ein Gespräch führen möchtest, gib diese bitte hier an."}
					</Typography>
					<Paper className={classes.subgroup}>
						<Grid container spacing={8}>
							{companies.map((company, index) => (
								<Grid item xs={12} sm={6} md={4} key={"exclude-" + company.id}>
									<FormControlLabel
										className={classes.excludeCompany}
										control={
											<Checkbox
												name="companies_to_exclude"
												checked={participant.companies_to_exclude.includes(
													company.id
												)}
												onChange={handleFieldChange}
												value={company.id}
											/>
										}
										label={<Typography variant="caption" className={classes.excludeCompanyName}>{company.name}</Typography>}
										disabled={favoriteCompanyIds.includes(company.id)}
									/>
								</Grid>
							))}
						</Grid>
					</Paper>
				</Grid>

				<Grid item xs={12} align="center">
					<Button
						color="primary"
						variant="contained"
						onClick={() => {
							for (let i = 1; i <= 10; i++) {
								if ("company_" + i in participant) {
									const favoriteIndex = i - 1;
									const favorite = favoriteIndex < favorites.length ? favorites[favoriteIndex] : null;
									if (favorite) {
										participant["company_" + i] = favorite.id;
										participant["company_" + i + "_jobpositions"] = favorite.positions;
										participant["company_" + i + "_why"] = favorite.why ? favorite.why : "";
									} else {
										participant["company_" + i] = "";
										participant["company_" + i + "_jobpositions"] = [];
										participant["company_" + i + "_why"] = "";
									}

								}
							}
							setActiveStep(2);
						}}
					>
						{language === "en" ? "continue >" : "weiter >"}
					</Button>
					<br />
					<br />
					<Button
						size="small"
						onClick={() => {
							setActiveStep(0);
						}}
					>
						{language === "en" ? "back" : "zurück"}
					</Button>
					{/* {formphase === "registration" &&
						<Typography variant="caption">
							<br />
							{language === "en" ? "Choose up to 7 favorites and then proceed to registration." : "Wähle links bis zu 7 Unternehmen und Jobs und gehe dann weiter zur Anmeldung."}
						</Typography>
					} */}
				</Grid>
			</Grid>
		</div >
	);

}

export default withStyles(styles)(CompanyPriorities);
